import { updates } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            最新快讯
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台动态速览
          </h2>
          <p className="mt-2 text-sm text-foreground-600">最新上线、活动与功能更新</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-6">
            {updates.map((item) => (
              <div key={item.id} className="relative pl-12 md:pl-16">
                <div className="absolute left-3 md:left-[22px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>

                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <span className="inline-block px-2.5 py-0.5 rounded-md bg-background-200 text-foreground-600 text-xs font-mono whitespace-nowrap">
                    {item.date}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
                      <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        item.tag === '新片上线' ? 'bg-accent-100 text-accent-700' :
                        item.tag === '活动' ? 'bg-primary-100 text-primary-700' :
                        item.tag === '技术' ? 'bg-secondary-100 text-secondary-700' :
                        'bg-background-200 text-foreground-600'
                      }`}>
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-600">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}